import { useHistory, useParams } from 'react-router-dom';
import { StringParam, useQueryParams } from 'use-query-params';

import { PageLayout } from '@/components/templates/PageLayout';
import { CmCard } from '@/components/uiParts';
import { redirect404Page } from '@/lib/AccessControl';
import { routes } from '@/router';
import { useManagerAccountMe } from '@/services/AuthEnterprise/hooks';

import AccountFrom from '../components/AccountFrom';

const CamelKioskAccountCreatePage: React.FC = () => {
  // /* アクセス制御 */
  const history = useHistory();
  const { managerAccountMe } = useManagerAccountMe();
  redirect404Page('camel_kiosk_account_management', history, managerAccountMe);

  const { id } = useParams<{ id: string }>();
  const qp = useQueryParams({ name: StringParam });
  const name = qp[0].name;

  return (
    <PageLayout title={routes.CamelKioskAccountCreate.title}>
      <CmCard mt="25px" height={`calc(100vh - 120px)`}>
        <AccountFrom
          storeId={id}
          storeName={name || ''}
          kioskAccountId={null}
          type="create"
        />
      </CmCard>
    </PageLayout>
  );
};

export default CamelKioskAccountCreatePage;
